var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Header'),_c('Sider',{attrs:{"sideData":_vm.siderData}}),_c('div',{staticClass:"content"},[_c('div',{staticClass:"content-card"},[_c('router-view',{staticClass:"content-body"})],1)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }